//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { LibraryTrackingIds } from '@legacy-components/content/libraryConstants';
import collapsableSectionTemplate from '@legacy-components/filters/collapsable-section.html';

(function () {
  const content = angular.module('curalate');

  /**
   * Reusable component with a title and content where clicking the title toggles expanding/collapsing the content. The content is included through
   * transclusion.
   * @param {string} title - text to use as section title
   * @param {string} iconSrc - source url of icon to place next to title text
   * @param {string} titleClass - class to apply to title of section
   * @param {string} sectionClass - class to apply to entire section
   * @param {boolean} expanded - true to have the section initially expanded, false to have the section initially collapsed. Defaults to true if not provided
   */
  content.component('collapsableSection', {
    bindings: {
      sectionTitle: '@',
      iconSrc: '@',
      expanded: '<',
      sectionTooltip: '<?',
      showManageLabelsButton: '<?',
    },
    template: collapsableSectionTemplate,
    transclude: true,
    controller: [
      '$sce',
      '$scope',
      function ($sce, $scope) {
        const self = this;
        $scope.model = {
          iconSrc: self.iconSrc,
          trackingId: LibraryTrackingIds.LABEL_MANAGEMENT_ENTRY_POINT,
          titleClass: self.titleClass,
          sectionTitle: self.sectionTitle,
          sectionClass: self.sectionClass,
          expanded: self.expanded === undefined ? true : self.expanded,
        };

        $scope.toggleExpand = function () {
          $scope.model.expanded = !$scope.model.expanded;
        };

        $scope.model.getTitle = function () {
          return $sce.trustAsHtml(self.sectionTitle);
        };
      },
    ],
  });
})();
